/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Meta_TitleInputs */

const en_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing, Shoot Share Connect`)
};

const es_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios — Shoot Share Connect`)
};

const fr_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs — Shoot Share Connect`)
};

const de_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise — Shoot Share Connect`)
};

const ja_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金プラン — Shoot Share Connect`)
};

const zh_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价 — Shoot Share Connect`)
};

const ar_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار — Shoot Share Connect`)
};

const id_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga — Shoot Share Connect`)
};

const it_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi — Shoot Share Connect`)
};

const ru_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тарифы — Shoot Share Connect`)
};

const pt_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços — Shoot Share Connect`)
};

const ko_pricing_meta_title = /** @type {(inputs: Pricing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금제 — Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Pricing, Shoot Share Connect" |
*
* @param {Pricing_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_meta_title = /** @type {((inputs?: Pricing_Meta_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Meta_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_meta_title(inputs)
	if (locale === "es") return es_pricing_meta_title(inputs)
	if (locale === "fr") return fr_pricing_meta_title(inputs)
	if (locale === "de") return de_pricing_meta_title(inputs)
	if (locale === "ja") return ja_pricing_meta_title(inputs)
	if (locale === "zh") return zh_pricing_meta_title(inputs)
	if (locale === "ar") return ar_pricing_meta_title(inputs)
	if (locale === "id") return id_pricing_meta_title(inputs)
	if (locale === "it") return it_pricing_meta_title(inputs)
	if (locale === "ru") return ru_pricing_meta_title(inputs)
	if (locale === "pt") return pt_pricing_meta_title(inputs)
	return ko_pricing_meta_title(inputs)
});